import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 177 (Sales Bible v2) — the manual tracking fields saved per job (proposal).
export interface SalesBibleFields {
  platform: string;
  deploymentDate: string; // yyyy-MM-dd or ''
  illustrationsComplete: string;
  projectLeadPayoutInput: string;
  notes: string;
}

// POST /api/proposal/SalesBible/{id} — status-independent update of a job's tracking
// columns. Refetches the proposals list (the Sales Bible's source) on completion.
const useSalesBibleActions = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (vars: { id: string; fields: SalesBibleFields }) => axios.post(
      `${apiUrl()}proposal/SalesBible/${vars.id}`,
      {
        platform: vars.fields.platform || null,
        deploymentDate: vars.fields.deploymentDate || null,
        illustrationsComplete: vars.fields.illustrationsComplete || null,
        projectLeadPayoutInput: vars.fields.projectLeadPayoutInput || null,
        notes: vars.fields.notes || null,
      },
    ),
    {
      onSettled: () => {
        queryClient.invalidateQueries('proposals');
        queryClient.invalidateQueries('workOrders'); // item 1210 — WO rows save here too
      },
    },
  );
  return {
    save: (id: string, fields: SalesBibleFields) => mutation.mutateAsync({ id, fields }),
    isSaving: mutation.isLoading,
  };
};

export default useSalesBibleActions;
